import { getEnvironmentConfig } from '@/constants/config';
import { RESERVE_WITH_GOOGLE_PARTNER_ID } from '@/constants/environments';

import type { RwgConversionPayload } from './reportRwgConversion';

/**
 * Reports a completed booking to Google so it can be credited to Reserve with
 * Google.
 *
 * Deliberately sends no `Content-Type` header and never reads the response:
 * that keeps this a CORS-simple POST, which is the only form the browser will
 * let reach Google's endpoint. Failures are swallowed — the booking is already
 * confirmed by the time this runs and must never be held up by it.
 */
export const reportRwgConversion = ({
  token,
  merchantChanged,
}: RwgConversionPayload): void => {
  try {
    void fetch(getEnvironmentConfig().reserveWithGoogleConversionUrl, {
      method: 'POST',
      // The success handler navigates immediately after this fires. Without
      // `keepalive` the browser cancels the request on teardown and the
      // conversion is lost for good, since the token is cleared either way.
      // It stays a CORS-simple POST. SQR-16105.
      keepalive: true,
      body: JSON.stringify({
        conversion_partner_id: RESERVE_WITH_GOOGLE_PARTNER_ID,
        rwg_token: token,
        merchant_changed: merchantChanged,
      }),
    }).catch(() => {
      // Network failure: nothing to do, and nothing the customer should see.
    });
  } catch {
    // `fetch` unavailable, or blocked by a browser extension.
  }
};
